import myPicture from '../../assets/photo_2024-07-27_21-13-09.jpg';
import styles from './About.module.css'

const About = () => {


    const age = new Date().getFullYear() - 2005;
    return (
        <section className={styles.about} id='about'>
            <div className={styles.width}>
                <div className={`h-auto mr-10 ${styles.background}`}>
                    <h2 className={styles.title}>Who am I?</h2>
                    <h1 className={styles.preTitle}>I am David Bogomolov, a Designer and Frontend Developer</h1>
                    <p className={styles.description}>Front-end developer with great energy, skilled in coding and
                        communication. Enjoys basketball and YouTube in free time.</p>
                    <div className={`flex flex-wrap  items-center text-right ${styles.justify}`}>
                        <div className='mr-28'>
                            <p className={`my-5 ${styles.preDescription}`}>Name: David</p>
                            <p className={`my-5 ${styles.preDescription}`}>Age: {age}</p>
                        </div>
                        <div className=''>
                            <p className={`my-5 ${styles.preDescription}`}>From: Ukraine,Kyiv</p>
                            <p className={`my-5 ${styles.preDescription}`}>Email: david.bogomolov2@gmail.com</p>
                        </div>
                    </div>
                    <div className={`${styles.justifyButton} flex `}>
                        <a href="https://drive.google.com/uc?id=1568_EqU6rMQropSSwxhmYBKn-klhil48&export=download" download="CV" className={`${styles.button}`}>Download CV</a>
                    </div>
                </div>
                <div className={` h-auto flex justify-center w-1/2`}>
                    <img src={myPicture} alt="me" className={'w-96 z-10 opacity-80 object-contain'}/>
                </div>
            </div>
        </section>
    )
}


export default About